module.exports = __webpack_public_path__ + "static/media/Karina Devine Headshot.6a2628bc.jpeg";